<template>
  <Modal :Content="modalContent" />
  <div class="container-fluid">
    <div class="loader-container" v-show="orderHandler == 0"><div class="loader"></div></div>
    <nav class="navbar"><div class="mx-auto"><a class="navbar-brand">{{Shop?.Name}}</a></div></nav>
    <Order :Cart="Cart" :Total="Total" :activityContent="activityContent" />
    <span v-show="!isGroupbuy">
      <Consumer :diningModel="diningModel" :shopAddress="shopAddress" :orderHandler="orderHandler" />
    </span>
    <PayMethod v-show="!isGroupbuy" :hasLINEPay="Shop?.hasLINEPay" :orderHandler="orderHandler" />
    <UserStatement v-show="!isGroupbuy" />
    <ShopStatement v-show="shopStatement" />
    <PlatformDeclaration />
    <Confirmation />
    <GroupbuyTipModal />
    <div class="row Footer">
      <div class="col" @click="goBack()">
        <i class="fas fa-undo-alt"></i><span>返回上頁</span>
      </div>
      <!-- 前往結帳一律可點，點擊時若店家不在線會顯示訊息 -->
      <div class="col" :class="{ disabled: orderHandler > -1 }" @click="beforeCheckout()">
        <i class="fas fa-cart-plus"></i>
        <span v-if="!isGroupbuy">前往結帳</span>
        <span v-else>送單給主揪</span>
      </div>
    </div>
  </div> 
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'

import Modal from '@/components/Modal'
import Order from '@/components/Pay/Order'
import Consumer from '@/components/Pay/Consumer'
import PayMethod from '@/components/Pay/PayMethod'
import PlatformDeclaration from '@/components/Pay/PlatformDeclaration'
import ShopStatement from '@/components/Pay/ShopStatement'
import UserStatement from '@/components/Pay/UserStatement'
import Confirmation from '@/components/Pay/Confirmation'
import GroupbuyTipModal from "@/components/Pay/GroupbuyTipModal"

import { groupbuy } from '@/mixins/Groupbuy'
import { LINENotify } from '@/mixins/LINENotify'

import { getDeclarations, getShopByShopId, createOrder, createOrderByGuest, GroupbuyEvent } from '@/Service/APIService'
import SocketService from '@/Service/SocketService'

export default {
  name: "Cart",
  components: {
    Modal,
    Order,
    Consumer,
    PayMethod,
    PlatformDeclaration,
    ShopStatement,
    UserStatement,
    Confirmation,
    GroupbuyTipModal
  },
  mixins: [LINENotify],
  data() {
    return {
      Shop: Global.Shop, // 店家資料
      Cart: null, // 購物車資料
      GrayOrder: null, // 系統檢查後停售或是不存在的商品
      discountPrice: null, // 折扣後價格
      diningModel: null, // 用餐模式，外帶、內用、外送
      Time: this.$moment(new Date()).add(Global?.Shop?.mealInterval + 1, 'minutes').format('HH:mm'), // 取餐時間
      tableNumber: "", // 桌號
      insideCaptcha: null, // 內用驗證碼
      Address: Global?.User?.Address || 'addAddress', // 外送地址
      Statement: null, // 消費者訂單備註
      payMethod: "現金", // 付款方式，現金、LINE Pay
      platformDeclaration: null, // 平台宣言
      shopStatement: null, // 店家宣言
      activityContent: null, // 活動敘述
      isGroupbuy: false, // 是否為參與團購者
      orderHandler: -1, // 訂單狀態，-1：未送出，0：送出中，1：已送出
      groupBuyNoRecardTime: 10, // 團購回應時間
      modalContent: null // Modal 訊息
    }
  },
  computed: {
    /** 店家是否在線；用於結帳前檢查 */
    shopOnline() {
      return SocketService.getShopOnline(this.$data.Shop?.id)
    },
    /** 訂單總金額（購物車內所有品項數量 × 單價加總） */
    'Total': function() {
      let Total = 0
      if (this.$data.Cart == null) return Total
      this.$data.Cart.forEach(User => { 
        User.Data.forEach(i => {
          Total += i.Count * i.Price 
        })
      })
      return Total
    },
    /** 店家完整地址（縣市 + 行政區 + 地址） */
    'shopAddress': function() {
      return this.$data.Shop?.County + this.$data.Shop?.District + this.$data.Shop?.Address
    },
  },
  methods: {
    /** 初始化：還原購物車、團購資料、平台/店家宣言，並訂閱店家在線狀態；無店家時導回店家頁 */
    init: async function() {
      /* 如果沒有店家就跳回首頁 */
      if (!this.$data.Shop) {
        swal.alertError("您剛重整了網頁，點餐資料已清除，須重新進行點餐", () => {
          this.$router.push({ path: `/Shop/${localStorage.getItem("lookAtShopById")}` })
        })
        return false
      }

      /* 取得購物車資料 */
      this.$data.Cart = Global.Cart

      /* 是否為參與團購者 */
      if (this.$route.query.Token) {
        if (!Global.Groupbuy.hasOwnProperty(this.$route.query.Token)) {
          this.$data.isGroupbuy = true
        } else {
          if (Global.Groupbuy[this.$route.query.Token] != null) {
            this.$data.Cart = this.$data.Cart.concat(Global.Groupbuy[this.$route.query.Token])
            Global.Cart = this.$data.Cart
          }
        }
      }
      this.$data.GrayOrder = new Array(this.$data.Cart.length)
      for (let i = 0 ; i < this.$data.Cart.length ; i++) this.$data.GrayOrder[i] = new Array(this.$data.Cart[i].Data.length)

      /* 取得平台宣言及店家告示 */
      const response = await getDeclarations(Global.Shop.id)

      this.$data.platformDeclaration = response.data.platformDeclaration 
      this.$data.shopStatement = response.data.shopStatement

      /* 由 SocketService 統一監聽店家在線狀態 */
      if (this.$data.Shop?.id) SocketService.watchShop(this.$data.Shop.id)
    },
    /** 組裝訂單參數並呼叫 API 建立訂單；成立後依付款方式導向 LINE Pay 或訂單列表 */
    Checkout: async function() {
      let tempTableNumber, tempAddress, isUser = null
      if (this.$data.diningModel == "內用") {
        tempTableNumber = this.$data.tableNumber
      } else if (this.$data.diningModel == "外送")  {
        tempAddress = this.$data.Address
      }
      isUser = Global.isGuest ? false : true

      const params = {
        shopId: Global.Shop.id,
        userId: Global.User.id,
        groupbuyToken: this.$route.query.Token,
        isUser: isUser,
        Price: this.Total,
        discountPrice: this.$data.discountPrice,
        takeMealTime: this.$moment(new Date()).format("YYYY-MM-DD") + " " + this.$data.Time,
        payMethod: this.$data.payMethod,
        diningModel: this.$data.diningModel,
        Order: this.$data.Cart,
        tableNumber: tempTableNumber,
        Address: tempAddress,
        Statement: this.$data.Statement,
        Activity: this.$data.activityContent
      }

      let response
      try {
        if (Global.isGuest) {
          response = await createOrderByGuest(params)
        } else {
          response = await createOrder(params)
        }
      } catch (err) {
        this.$data.orderHandler = -1
        const msg = err.response?.data?.Message
        if (msg === 'SHOP_OFFLINE') {
          await swal.alertError(Global.MESSAGE.CART.SHOP_OFFLINE)
          this.$router.push({ path: `/Shop/${Global.Shop?.id}` })
          return
        }
        await swal.alertError(Global.MESSAGE.ERROR.MESSAGE)
        return
      }

      let orderId = response.data.orderId
      let serialId = response.data.serialId
      switch (response.data.Message) {
        case Global.API.ORDER.CREATED:
          this.orderCreated(orderId, serialId)
          break
      }
    },
    /** 傳送團購資料給主揪，並監聽主揪回應；若主揪不在線則由計時器提示 */
    sendGroupbuy: function() {
      if (this.$data.Cart[0].Data.length == 0) return swal.alertError('您的購物車是空的', this.$router.go(-1))
      let Token = this.$route.query.Token
      let User = { userId: Global.User.id, userName: Global.User.Name }
      Global.Cart[0].User = User
      
      const params = { Token: Token, User: User, isOwn: false, Data: Global.Cart }

      GroupbuyEvent(params)

      this.$data.orderHandler = 0
      this.groupBuyNoRecardTimer()

      const GroupbuyChannel = window.Echo.channel('GroupbuyChannel.' + Token)
      GroupbuyChannel.listen('.GroupbuyEvent', (e) => {
        if (e.isOwn == false) return false
        if (e.User.userId != Global.User.id) return false
        if (this.$data.orderHandler == 0) {
          this.$data.orderHandler = 1
          $("#GroupbuyTipModal").modal('show')
          localStorage.removeItem("Cart." + this.$data.Shop.id)
        }
      })
    },
    /** 團購倒數計時：十秒內主揪無回應則取消並提示，否則每秒遞減 */
    groupBuyNoRecardTimer: function() {
      this.$data.groupBuyNoRecardTime -= 1
      if (this.$data.groupBuyNoRecardTime == 0) {
        this.$data.orderHandler = -1
        this.$data.modalContent = "主揪不在線，無法送團購單，如有疑問請聯繫主揪哦！"
        $("#NormalModal").modal('show')
        this.$router.push({ name: "Home" })
      }
      if (this.$data.groupBuyNoRecardTime > 0 && this.$data.orderHandler == 0) {
        setTimeout(() => { this.groupBuyNoRecardTimer() }, 1000);
      }
    },
    /** 訂單成立後：清除本地購物車，依付款方式導向 LINE Pay 或訂單列表 */
    orderCreated: function(orderId, serialId) {
      localStorage.removeItem("Cart." + this.$data.Shop.id)
      let orderPrice = this.$data.discountPrice ? this.$data.discountPrice : this.Total
      /* 付款方式：LINE Pay */
      if (this.$data.payMethod == "LINE Pay") {
          let Order = { 
            id: orderId,
            shopId: Global.Shop.id,
            serialId: serialId,
            diningModel: this.$data.diningModel,
            Price: orderPrice,
            takeMealTime: this.$moment(new Date()).format("YYYY-MM-DD") + " " + this.$data.Time,
            userName: Global.User.Name
          }
          this.$cookies.set("Order", JSON.stringify(Order), "1h")
          this.$router.push({ name: `LINEPayRequest` })
      /* 付款方式：現金 */
      } else {
        this.$router.push({ name: `Orders` })
        return false
      }
    },
    /** 結帳前檢查：若為團購則送團購單，否則檢查店家狀態與購物車資料後送出訂單 */
    beforeCheckout: async function() {
      /* 判斷是否在處理訂單中 */
      if (this.$data.orderHandler > -1) return false
      this.$data.orderHandler = 0

      /* 確認是否為團購者 */
      if (this.$data.isGroupbuy) {
        if (!await this.checkProductIsRight()) {
          this.$data.orderHandler = -1
          this.$data.modalContent = Global.MESSAGE.CART.PRODUCT_NO_SALE
          $("#NormalModal").modal('show')
          return false
        }
        this.sendGroupbuy()
      } else {
        /* 先取得店家最新狀態與營業時間，若店家剛改暫停／公休／營業時間則阻止送單 */
        if (!await this.checkShopStatusAndHours()) {
          this.$data.orderHandler = -1
          return false
        }
        /* 判斷購物車資料是否正確 */
        if (!await this.checkCartDataIsRight()) {
          this.$data.orderHandler = -1
          return false
        }
        this.Checkout()
      }
    },
    /** 取得店家最新資料並檢查：接單狀態（暫停／公休）、營業時間、是否在線；不符則阻擋送單並顯示訊息 */
    checkShopStatusAndHours: async function () {
      const shopId = Global.Shop?.id
      if (!shopId) {
        await swal.alertError(Global.MESSAGE.CART.SHOP_NOT_ONLINE)
        this.$router.push({ name: 'Home' })
        return false
      }
      try {
        const res = await getShopByShopId(shopId)
        const shop = res?.data?.Shop
        if (!shop) {
          await swal.alertError(Global.MESSAGE.CART.SHOP_NOT_ONLINE)
          this.$router.push({ path: `/Shop/${shopId}` })
          return false
        }
        this.$data.Shop = shop
        Global.Shop = shop
      } catch (_) {
        await swal.alertError(Global.MESSAGE.CART.SHOP_NOT_ONLINE)
        this.$router.push({ path: `/Shop/${shopId}` })
        return false
      }
      const orderStatus = this.$data.Shop.orderStatus
      const now = this.$moment()
      const openingMoment = this.$moment(this.$data.Shop.openingTime, 'HH:mm')
      const closingMoment = this.$moment(this.$data.Shop.closingTime, 'HH:mm')
      if (orderStatus === '暫停') {
        await swal.alertError(Global.MESSAGE.CART.SHOP_ORDERSTATUS_PAUSED)
        this.$router.push({ path: `/Shop/${shopId}` })
        return false
      }
      if (orderStatus === '公休') {
        await swal.alertError(Global.MESSAGE.CART.SHOP_ORDERSTATUS_DAYOFF)
        this.$router.push({ path: `/Shop/${shopId}` })
        return false
      }
      if (now.isAfter(closingMoment) || now.isBefore(openingMoment)) {
        await swal.alertError(Global.MESSAGE.CART.SHOP_ORDERSTATUS_NORMAL)
        this.$router.push({ path: `/Shop/${shopId}` })
        return false
      }
      if (!this.shopOnline) {
        await swal.alertError(Global.MESSAGE.CART.SHOP_NOT_ONLINE)
        this.$router.push({ path: `/Shop/${shopId}` })
        return false
      }
      return true
    },
    /** 結帳前驗證：購物車有內容、金額、商品可售、用餐模式、取餐時間、內用桌號/驗證碼、外送地址等 */
    checkCartDataIsRight: async function () {
      const showError = (message) => {
        this.$data.modalContent = message
        $("#NormalModal").modal('show')
        return false
      }

      const now = this.$moment()
      const mealReadyMoment = now.clone().add(this.$data.Shop.mealInterval, 'minutes')
      const closingMoment = this.$moment(this.$data.Shop.closingTime, "HH:mm")
      const orderTimeMoment = this.$moment(this.$data.Time, "HH:mm")

      /** 驗證結果：true 通過，或 { message, fix } 不通過（fix 為選用的補正函式） */
      const validators = [
        {
          run: () => this.$data.Cart[0].Data.length !== 0,
          message: Global.MESSAGE.CART.CART_NOTHING
        },
        {
          run: () => this.Total >= 0 && (this.$data.discountPrice == null || this.$data.discountPrice >= 0),
          message: Global.MESSAGE.CART.CART_PRICE_LESS_ZERO
        },
        {
          run: () => this.checkProductIsRight(),
          message: Global.MESSAGE.CART.PRODUCT_NO_SALE,
          async: true
        },
        {
          run: () => !!this.$data.diningModel,
          message: Global.MESSAGE.CART.DININGMODAL_NO_CHOOSE
        },
        // 一般營業且非內用：備餐不可超過打烊、取餐時間區間
        {
          run: () => {
            if (Global.Shop.businessModel !== "一般" || this.$data.diningModel === "內用") return true
            if (!mealReadyMoment.isBefore(closingMoment)) return { message: Global.MESSAGE.CART.SHOP_CLOSING }
            if (orderTimeMoment.isBefore(mealReadyMoment)) {
              this.$data.Time = mealReadyMoment.clone().add(1, 'minutes').format("HH:mm")
              return { message: Global.MESSAGE.CART.TAKEMEALTIME_MISTAKE + this.$data.Time }
            }
            if (orderTimeMoment.isAfter(closingMoment)) return { message: Global.MESSAGE.CART.TAKEMEALTIME_NOT_IN_BUSINESS }
            return true
          },
          message: null
        },
        // 內用：打烊、驗證碼、桌號
        {
          run: () => {
            if (this.$data.diningModel !== "內用") return true
            if (!mealReadyMoment.isBefore(closingMoment)) return { message: Global.MESSAGE.CART.SHOP_CLOSING }
            if (this.$data.insideCaptcha !== this.$data.Shop.insideCaptcha) return { message: Global.MESSAGE.CART.INSIDE_CAPTCHA_ERROR }
            if (this.$data.tableNumber.length > 4) return { message: Global.MESSAGE.CART.INSIDE_TABLE_NUMBER_EXCEED }
            if (this.$data.tableNumber.length === 0) return { message: Global.MESSAGE.CART.INSIDE_TABLE_NUMBER_NULL }
            return true
          },
          message: null
        },
        // 外送：地址、免運門檻、取餐時間
        {
          run: () => {
            if (this.$data.diningModel !== "外送") return true
            if (this.$data.Address === "addAddress") return { message: Global.MESSAGE.CART.DELIVERY_NULL }
            if (this.$data.Shop.deliveryPrice > 0) {
              const discountPrice = this.$data.discountPrice ?? this.Total
              if (discountPrice < this.$data.Shop.deliveryPrice) {
                this.$parent.$data.diningModel = null
                return { message: Global.MESSAGE.CART.DELIVERY_PRICE_NOT_REACH_STANDARD }
              }
            }
            const mealDeliveryReadyMoment = now.clone().add(this.$data.Shop.mealInterval + this.$data.Shop.deliveryTime, 'minutes')
            if (orderTimeMoment.isBefore(mealDeliveryReadyMoment)) {
              this.$data.Time = mealDeliveryReadyMoment.clone().add(1, 'minutes').format("HH:mm")
              return { message: Global.MESSAGE.CART.TAKEMEALTIME_MISTAKE_2 + this.$data.Time }
            }
            return true
          },
          message: null
        }
      ]

      for (const v of validators) {
        const result = v.async ? await v.run() : v.run()
        const fail = result === true ? null : (typeof result === 'object' && result?.message != null ? result : { message: v.message })
        if (fail) return showError(fail.message)
      }
      return true
    },
    /** 確認購物車內商品是否存在且可售（含標籤與細項）；不可售的會標記為 GrayOrder */
    checkProductIsRight: async function () {
      /* 取得店家資料跟菜單 */
      const params = { ShopJWT: localStorage.getItem("ShopJWT") }
      const response = await getShopByShopId(Global.Shop.id, params)

      let productsData = response.data.productsData
      /* 是否購物車內容有誤（沒貨或商品不存在） */
      let cartError = false
      let tempCart = this.$data.Cart
      /* 迴圈購物者 */
      for (const userIndex in tempCart) {
        /* 迴圈購物者下的商品 */
        let userData = tempCart[userIndex].Data
        for (const productIndex in tempCart[userIndex].Data) {
          let hasProduct = false // 判斷是否有貨
          /* 迴圈店家的類別 */
          for (const productCategoryData of productsData) {
            /* 判斷商品類別 */
            if (userData[productIndex].productCategoryId == productCategoryData.id) {
              /* 迴圈店家類別下的商品 */
              for (const ProductData of productCategoryData.Products) {
                /* 判斷商品是否存在且是否有貨 */
                if (userData[productIndex].productId == ProductData.id && ProductData.salesStatus == 1) {
                  /* 判斷是否有標籤 */
                  if (ProductData.productLabels.length > 0) {
                    let hasItems = true
                    /* 迴圈購物者下商品的細項 */
                    for (const Item of userData[productIndex].Items) {
                      let hasItem = false // 判斷細項是否存在且是否有貨
                      /* 迴圈店家類別下的商品下的標籤 */
                      for (const productLabelData of ProductData.productLabels) {
                        /* 判斷標籤是否符合 */
                        if (Item.labelId == productLabelData.id) {
                          /* 迴圈店家類別下的商品下的標籤下的細項 */
                          for (const productItemData of productLabelData.productItems) {
                            /* 判斷細項是否存在且是否有貨 */
                            if (Item.itemId == productItemData.id && productItemData.salesStatus == 1) {
                              hasItem = true
                            }
                          }
                        }
                      }
                      if (!hasItem) hasItems = false
                    }
                    if (hasItems) hasProduct = true
                  } else {
                    hasProduct = true
                  }
                }
              }
            }
          }
          /* 如果沒貨 */
          if (!hasProduct) {
            cartError = true
            this.$data.GrayOrder[userIndex][productIndex] = true
          }
        }
      }
      return !cartError
    },
    /** 首次進入時詢問是否啟用 LINE Notify 取餐通知；若選擇啟用則導向綁定流程 */
    checkInitialLineNotifyUsage: function() {
      if (localStorage.getItem("lineNotifyUsageChecked") != null) return false
      return confirm("是否啟用 LINE Notify 通知取餐？") ? this.setLINENotify({ redirectToPage: "Orders" }) : localStorage.setItem("lineNotifyUsageChecked", false)
    },
    /** 返回該店家頁面（有團購 Token 則帶上）；送單中不允許返回 */
    goBack: function() {
      if (this.$data.orderHandler > -1) return false
      this.$route.query.Token ? this.$router.push({ path: `/Shop/${Global.Shop.id}/${this.$route.query.Token}` }) : this.$router.push({ path: `/Shop/${Global.Shop.id}` })
    },
  },
  /** 掛載時執行初始化（載入購物車、宣言、訂閱店家） */
  mounted() {
    this.init()
  },
  /** 卸載時取消監聽店家在線狀態 */
  beforeUnmount() {
    if (this.$data.Shop?.id) SocketService.unwatchShop(this.$data.Shop.id)
  }
}
</script>

<style lang="scss" scoped>
.loader-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  .loader {
    width: 50px;
    height: 50px;
    border: 5px solid;
    color: #5599FF;
    border-radius: 50%;
    border-top-color: transparent;
    animation: loader 1s linear infinite;
  }
}
@keyframes loader {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.container-fluid, .row {
  margin: 0px;
  padding: 0px;
  background-color: #EEEEEE;
}
.navbar {
  margin-bottom: 15px;
  padding: 0px 20px;
  height: 8vh;
  background-color: #5599FF;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 900;
  .mx-auto {
    .navbar-brand {
      margin: 0px;
      color: #FFFFFF;
    }
  }
}
.Footer {
  position: fixed;
  display: flex;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #5599FF;
  .col {
    text-align: center;
    line-height: 70px;
    font-size: 20px;
    font-weight: 900;
    color: #FFFFFF;
    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }
    span {
      display: inline-block;
      margin-left: 15px;
    }
  }
}
</style>